var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditStageTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#A6E2DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.0002H10L16.5625 11.4377C16.7267 11.2735 16.8569 11.0787 16.9457 10.8642C17.0345 10.6497 17.0803 10.4198 17.0803 10.1877C17.0803 9.95554 17.0345 9.72567 16.9457 9.51119C16.8569 9.29672 16.7267 9.10184 16.5625 8.93769C16.3983 8.77354 16.2035 8.64332 15.989 8.55449C15.7745 8.46565 15.5446 8.41992 15.3125 8.41992C15.0804 8.41992 14.8505 8.46565 14.636 8.55449C14.4215 8.64332 14.2267 8.77354 14.0625 8.93769L7.5 15.5002V18.0002Z",
    stroke: "#2B7B79",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 9.5625L15.9375 12.0625",
    stroke: "#2B7B79",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditStageTeal);
export default __webpack_public_path__ + "static/media/Icon_EditStage_Teal.967ffb349a4f8ed44ee4a6cbf7d67cb1.svg";
export { ForwardRef as ReactComponent };